import { NavigationItem } from '../../Components/NavigationItem/NavigationItem';
import { GroceriesIcon } from '../../Icons/Groceries';
import { HomeIcon } from '../../Icons/Home';
import { LocationsIcon } from '../../Icons/Locations';
import { MoviesIcon } from '../../Icons/Movies';
import { RemindersIcon } from '../../Icons/Reminders';
import { SettingsIcon } from '../../Icons/Settings';
import { LogoutIcon } from '../../Icons/Logout';
import { ExerciseLogsIcon } from '../../Icons/ExerciseLogs';

import sidebarStyles from './Sidebar.module.css';
import layoutStyles from '../Layout.module.css';
import { useLoginContext } from '../../Contexts/Login.Context';

export const Sidebar = () => {
  const { setToken } = useLoginContext();

  const logout = () => setToken(null);
  return (
    <div className={`${sidebarStyles.wrapper} ${layoutStyles.sidebar}`}>
      <div className={sidebarStyles.navigation}>
        <NavigationItem to="/home">
          <HomeIcon />
        </NavigationItem>
        <NavigationItem to="/groceries">
          <GroceriesIcon />
        </NavigationItem>
        <NavigationItem to="/locations">
          <LocationsIcon />
        </NavigationItem>
        <NavigationItem to="/reminders">
          <RemindersIcon />
        </NavigationItem>
        <NavigationItem to="/movies">
          <MoviesIcon />
        </NavigationItem>
        <NavigationItem to="/exercises">
          <ExerciseLogsIcon />
        </NavigationItem>

        <div className={sidebarStyles.bottomSection}>
          <NavigationItem to="/settings">
            <SettingsIcon />
          </NavigationItem>
          <div className={sidebarStyles.logoutButton} onClick={logout}>
            <LogoutIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
